// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#lid-worden label{color:red;font-weight:700}", "",{"version":3,"sources":["webpack://./resources/js/Pages/account/subscriptions/Status.vue"],"names":[],"mappings":"AACA,kBAEI,SAAA,CADA,eACJ","sourcesContent":["\n#lid-worden label {\n    font-weight: bold;\n    color: red;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
